// extracted by mini-css-extract-plugin
export default {"ace-c-panel-logo":"panel-logo---7929801d"};